import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const BOOK_BROWN = '#6B4423';
const BOOK_BROWN_DARK = '#4A2F18';
const BOOK_BROWN_LIGHT = '#8B5A2B';
const PAGE_EDGE = '#F5F0E6';

/**
 * Brown diary book tile art with the current year angled on the cover.
 */
export default function ClassBookTileArt({ year, style }) {
  const displayYear = year ?? new Date().getFullYear();

  return (
    <View style={[styles.wrap, style]}>
      <View style={styles.bookShadow} />
      <View style={styles.book}>
        <View style={styles.spine} />
        <View style={styles.pagesEdge} />
        <View style={styles.cover}>
          <View style={styles.coverBand} />
          <Text style={styles.year}>{displayYear}</Text>
          <View style={styles.coverLines}>
            <View style={styles.coverLine} />
            <View style={styles.coverLine} />
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    width: '88%',
    height: 92,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  bookShadow: {
    position: 'absolute',
    bottom: 4,
    width: '78%',
    height: 10,
    borderRadius: 8,
    backgroundColor: 'rgba(0,0,0,0.22)',
    transform: [{ skewX: '-8deg' }],
  },
  book: {
    width: '78%',
    height: 84,
    flexDirection: 'row',
    transform: [{ rotate: '-6deg' }],
    backgroundColor: 'transparent',
  },
  spine: {
    width: 10,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: BOOK_BROWN_DARK,
  },
  pagesEdge: {
    width: 5,
    backgroundColor: PAGE_EDGE,
    borderRightWidth: 1,
    borderRightColor: 'rgba(0,0,0,0.08)',
  },
  cover: {
    flex: 1,
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    backgroundColor: BOOK_BROWN_LIGHT,
    borderWidth: 1,
    borderColor: BOOK_BROWN_DARK,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 6,
  },
  coverBand: {
    position: 'absolute',
    top: 10,
    left: 8,
    right: 8,
    height: 8,
    borderRadius: 2,
    backgroundColor: BOOK_BROWN_DARK,
    opacity: 0.85,
  },
  year: {
    fontSize: 22,
    fontWeight: '800',
    color: '#F8F4EC',
    letterSpacing: 1,
    transform: [{ rotate: '-8deg' }],
    backgroundColor: 'transparent',
    textShadowColor: 'rgba(0,0,0,0.35)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  coverLines: {
    position: 'absolute',
    bottom: 12,
    left: 12,
    right: 12,
    gap: 4,
    backgroundColor: 'transparent',
  },
  coverLine: {
    height: 1,
    backgroundColor: 'rgba(255,255,255,0.25)',
  },
});
